export default function BrowserTop() {
  return (
    <svg
      width="100%"
      viewBox="0 0 880 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.734375 16.4453C0.734375 10.8448 0.734375 8.04452 1.82431 5.90541C2.78304 4.02379 4.31285 2.49398 6.19447 1.53525C8.33359 0.445312 11.1338 0.445312 16.7344 0.445312H863.734C869.335 0.445312 872.135 0.445312 874.274 1.53525C876.156 2.49398 877.686 4.02379 878.644 5.90541C879.734 8.04452 879.734 10.8448 879.734 16.4453V52.4453H0.734375V16.4453Z"
        fill="#FDFDFD"
      />
      <g clipPath="url(#clip0_395_63752)">
        <circle cx="26.7344" cy="26.4453" r="6" fill="#ED6A5E" />
        <circle
          cx="26.7344"
          cy="26.4453"
          r="5.5"
          stroke="black"
          strokeOpacity="0.1"
        />
        <circle cx="46.7344" cy="26.4453" r="6" fill="#F4BD50" />
        <circle
          cx="46.7344"
          cy="26.4453"
          r="5.5"
          stroke="black"
          strokeOpacity="0.1"
        />
        <circle cx="66.7344" cy="26.4453" r="6" fill="#61C454" />
        <circle
          cx="66.7344"
          cy="26.4453"
          r="5.5"
          stroke="black"
          strokeOpacity="0.1"
        />
      </g>
      <path
        d="M269.471 22.0453C269.471 18.685 269.471 17.0048 270.125 15.7214C270.7 14.5924 271.618 13.6745 272.747 13.0993C274.03 12.4453 275.71 12.4453 279.071 12.4453H600.871C604.231 12.4453 605.911 12.4453 607.195 13.0993C608.324 13.6745 609.241 14.5924 609.817 15.7214C610.471 17.0048 610.471 18.685 610.471 22.0453V30.8453C610.471 34.2056 610.471 35.8858 609.817 37.1693C609.241 38.2982 608.324 39.2161 607.195 39.7914C605.911 40.4453 604.231 40.4453 600.871 40.4453H279.071C275.71 40.4453 274.03 40.4453 272.747 39.7914C271.618 39.2161 270.7 38.2982 270.125 37.1693C269.471 35.8858 269.471 34.2056 269.471 30.8453V22.0453Z"
        fill="#F0F0F0"
      />
      <defs>
        <clipPath id="clip0_395_63752">
          <rect
            width="52"
            height="12"
            fill="white"
            transform="translate(20.7344 20.4453)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
